import { FormDefaultAttributes, type DatePickerConfig } from '@common';
import { PeriodBoundary } from '../../../models';

export const SOIL_TEMPERATURE_PERIOD_FORM_CONFIG = {
  name: 'soilTemperaturePeriodForm',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes()
  },
  children: [
    {
      name: 'fromDate',
      component: 'datepicker',
      attributes: {
        label: 'statistics.wizard.label.fromDate',
        itemTitle: 'name',
        displayFormat: 'yyyy.MM.dd.',
        format: 'yyyy-MM-dd',
        max: new Date(),
        closeCalendarOnPick: true
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 6
        }
      },
      validators: [
        {
          validator: 'smallerThan',
          settings: {
            otherFieldName: 'toDate',
            invalidMessage: 'statistics.form.validator.smallerThan.invalidMessage',
            needTranslate: true,
            allowEqual: false,
            otherFieldValueRequired: false
          }
        },
        {
          validator: 'soilTemperaturePeriodDate',
          settings: {
            otherFieldName: 'toDate',
            periodBoundary: PeriodBoundary.START,
            needTranslate: true
          }
        }
      ]
    } as DatePickerConfig,
    {
      name: 'toDate',
      component: 'datepicker',
      attributes: {
        label: 'statistics.wizard.label.toDate',
        itemTitle: 'name',
        displayFormat: 'yyyy.MM.dd.',
        format: 'yyyy-MM-dd',
        max: new Date(),
        closeCalendarOnPick: true
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 6
        }
      },
      validators: [
        {
          validator: 'greaterThan',
          settings: {
            otherFieldName: 'fromDate',
            invalidMessage: 'statistics.form.validator.greaterThan.invalidMessage',
            needTranslate: true,
            allowEqual: false,
            otherFieldValueRequired: false
          }
        },
        {
          validator: 'soilTemperaturePeriodDate',
          settings: {
            otherFieldName: 'fromDate',
            periodBoundary: PeriodBoundary.END,
            needTranslate: true
          }
        }
      ]
    } as DatePickerConfig
  ]
};
